import { useFormikContext } from 'formik';
import { useEffect } from 'react';

import type { ClientFormValues } from '../models/Forms';

import { getIdentityDocumentValidationFingerprint } from './identityDocumentFingerprint';

export function IdentityDocumentValidationFormEffects() {
  const { values, setValues, setFieldError } = useFormikContext<ClientFormValues>();

  useEffect(() => {
    const currentFingerprint = getIdentityDocumentValidationFingerprint(values);
    if (
      values.identityDocumentValidationFingerprint &&
      values.identityDocumentValidationFingerprint !== currentFingerprint
    ) {
      void setValues((current) => ({
        ...current,
        identityDocumentValidationStatus: undefined,
        identityDocumentValidationFingerprint: undefined,
      }));
      setFieldError('identificationNumber', undefined);
    }
  }, [setFieldError, setValues, values]);

  return null;
}
